import { ActionReducer } from '@ngrx/store';
import { StateManagementHelpers } from '../../helpers';
import * as UserProfileActions from '../actions/user-profile.actions';
import { IUserProfileStore } from '../interfaces/user-profile-store.interface';

const defaultUserProfile: IUserProfileStore = {
  name: '',
  userProfileId: -1,
};

export const userProfileReducer: ActionReducer<
  IUserProfileStore | undefined,
  any
> = (
  // eslint-disable-next-line default-param-last
  state: IUserProfileStore = defaultUserProfile,
  action: any,
): IUserProfileStore | undefined => {
  switch (action.type) {
    case UserProfileActions.USER_PROFILE_ID:
      return StateManagementHelpers.mergeState(state, {
        userProfileId: action.userProfileId,
      }) as IUserProfileStore;
    case UserProfileActions.ALL:
      return StateManagementHelpers.mergeState(state, {
        name: action.name,
        userProfileId: action.userProfileId,
      }) as IUserProfileStore;
    default:
      return state;
  }
};
